import React from "react";
import PropTypes from "prop-types";
import { Type } from "discover.medical.react-component-library";

const DEFAULT_LABEL = "No matches for the term provided";

const NoDataBanner = ({ label }) => (
  <Type element="em" color="gray800" fontSize="sm">
    {label || DEFAULT_LABEL}
  </Type>
);

NoDataBanner.propTypes = {
  label: PropTypes.string,
};

export default NoDataBanner;
